export class ReportSoakingRequest{
    productionLogId: number;
    outputGrade: number;
    workstation: number;
    lotNumber: string;
    outputQuantity: number;
    saleOrderItemId: number;
    plantId: number;
    
    constructor(
        productionLogId: number,
        outputGrade: number,
        workstation: number,
        lotNumber: string,
        outputQuantity: number,
        saleOrderItemId: number,
        plantId: number,
        ){
            this.productionLogId= productionLogId,
            this.outputGrade= outputGrade,
            this.workstation= workstation,
            this.lotNumber= lotNumber,
            this.outputQuantity = outputQuantity,
            this.saleOrderItemId = saleOrderItemId
            this.plantId = plantId
    }
}